export default "__VITE_PUBLIC_ASSET__6373517c__"